import { render, staticRenderFns } from "./WalletWithdrawalsTable.vue.vue?vue&type=template&id=38dac96c"
import script from "./WalletWithdrawalsTable.vue.vue?vue&type=script&lang=js"
export * from "./WalletWithdrawalsTable.vue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports